import { Button, Stack, Typography, useTheme } from "@mui/material";
import { FileTextIcon, PlusIcon } from "lucide-react";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { IconBox } from "web_myplann/Shared/Components/IconBox";

const R = Resources.Portfolio.List.Redesign.Documents;

type Props = {
	onAddDocument: () => void;
};

export const EmptyFolderState: FC<Props> = ({ onAddDocument }) => {
	const { palette, iconSize } = useTheme();
	const { t } = useResource();

	return (
		<Stack
			alignItems="center"
			justifyContent="center"
			height="100%"
			gap={2}
			px={2.5}
			textAlign="center"
		>
			<IconBox bg={palette.grey[100]} size={64}>
				<FileTextIcon size={28} color={palette.grey[400]} />
			</IconBox>
			<Typography variant="h3">{t(R.EmptyFolder.title)}</Typography>
			<Typography variant="body2">{t(R.EmptyFolder.description)}</Typography>
			<Button
				variant="primary"
				startIcon={<PlusIcon size={iconSize.sm} />}
				onClick={onAddDocument}
			>
				{t(R.addDocument)}
			</Button>
		</Stack>
	);
};
